module.exports = __webpack_public_path__ + "media/assets/images/logo-provider-f9bc443bf168d7e68ab3d4641a9fe829.png";